import React from 'react';
import { HomeworLabels, HomeworkStatus, HomeworkStatuses } from '../../../scenes/homeworkList/models/homeworkList-models';
import { MultiMappingSelect } from './base/MultiMappingSelect';
import { useTranslation, withTranslation } from 'react-i18next';


type HomeworkOption = {
  value: HomeworkStatus;
  label: string;
};

const HomeworkOptions: HomeworkOption[] = HomeworkStatuses.map(status => (
  {
    value: status,
    label: HomeworLabels[status]
  }
));


function getOptionValue(option: HomeworkOption) {
  return option.value;
}

function getOptionLabel(option: HomeworkOption) {
  return option.label;
}

type HomeworkSelectProps = {
  value: HomeworkStatus[];
  onChange: (roles: HomeworkStatus[]) => void;
  onBlur?: () => void;
};

export function HomeworkSelect(props: HomeworkSelectProps) {
  const { t } = useTranslation();

  return (
    <MultiMappingSelect<HomeworkOption, HomeworkStatus>
      options={HomeworkOptions}
      getValue={getOptionValue}
      getLabel={getOptionLabel}
      value={props.value}
      placeholder={t("homework.select-status")}
      onChange={props.onChange}
      onBlur={props.onBlur} />);
}